import { createSlice } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
  data: any[];
}

const initialState: InitialState = {
  status: ReduxStateType.INIT,
  data: [],
};

const getEmployeeOfManagerSlice = createSlice({
  name: "getEmployeeOfManager",
  initialState,
  reducers: {
    getEmployeeOfManagerStart: (state, action) => {
      state.status = ReduxStateType.LOADING;
    },
    getEmployeeOfManagerSuccess: (state, action) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = action.payload;
    },
    getEmployeeOfManagerFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
    resetGetEmployeeOfManager: (state) => initialState,
  },
});

export const {
  getEmployeeOfManagerStart,
  getEmployeeOfManagerSuccess,
  getEmployeeOfManagerFailed,
  resetGetEmployeeOfManager,
} = getEmployeeOfManagerSlice.actions;

export default getEmployeeOfManagerSlice.reducer;
